
const downloadableFormsMap = [
    {
        type : "SG34ChequeRequestForm",
        name : "SG3.4 Cheque Request Form",
        path : "DownloadableForms/SG3.4 Cheque Request Form.docx"
    },
    {
        type : "SG35ElectronicFundsTransferForm",
        name : "SG3.5 Electronic Funds Transfer Form",
        path : "DownloadableForms/SG3.5 Electronic Funds Transfer Form.docx"
    },
    {
        type : "SG4FraudPreventionChecklist",
        name : "SG4 Fraud Prevention Checklist",
        path : "DownloadableForms/SG4 Fraud Prevention Checklist.docx"
    },
    {
        type : "SG6EstimateofSellingPriceForm",
        name : "SG6 Estimate of Selling Price Form",
        path : "DownloadableForms/SG6 Estimate of Selling Price Form.docx"
    },
    {
        type : "SG61EstimateofSellingPriceChecklist",
        name : "SG6.1 Estimate of Selling Price Checklist",
        path : "DownloadableForms/SG6.1 Estimate of Selling Price Checklist.docx"
    },
    {
        type : "SG62AdvertisingMarketingandPromotionalMaterialChecklist",
        name : "SG6.2 Advertising Marketing and Promotional Material Checklist",
        path : "DownloadableForms/SG6.2 Advertising_ Marketing and Promotional material checklist.docx"
    },
    {
        type : "SG63AdvertisingContentForm",
        name : "SG6.3 Advertising Content Form",
        path : "DownloadableForms/SG6.3 Advertising Content Form.docx"
    },
    {
        type : "SG64Section47ReferralForm",
        name : "SG6.4 Section 47 Referral Form",
        path : "DownloadableForms/SG6.4 Section 47 referral form.docx"
    },
    {
        type : "SG6.5 Section 49 Beneficial Interest Form",
        name : "SG6.5 Section 49 Beneficial Interest Form",
        path : "DownloadableForms/SG6.5 Section 49 Beneficial Interest Form.docx"
    },
    {
        type : "SG6.6 Section 52 Material Fact Form",
        name : "SG6.6 Section 52 Material Fact Form",
        path : "DownloadableForms/SG6.6 Section 52 Material Fact Form.docx"
    },
    {
        type : "SG67FinancialInvestmentAdviceReferralToServiceProvidersChecklist",
        name : "SG6.7 Financial Investment Advice Referral to Service Providers Checklist",
        path : "DownloadableForms/SG6.7 Financial Investment advice referral to service providers checklist.docx"
    },
    {
        type : "SG68SalesNoteAuthorityToExchange",
        name : "SG6.8 Sales Note - Authority to Exchange",
        path : "DownloadableForms/SG6.8 Sales Note - Authority to Exchange.docx"
    },
    {
        type : "SG72LetterTemplate",
        name : "SG7.2 Letter Template",
        path : "DownloadableForms/SG7.2 Letter Template.docx"
    },
    {
        type : "SG8FairTradingWorkExperienceGuideTemplateForAssistantAgents",
        name : "SG8 Fair Trading Work Experience Guide Template For Assistant Agents",
        path : "DownloadableForms/SG8 Fair Trading Work Experience guide template for Assistant Agents.docx"
    },
    {
        type : "SG81RecruitQuestions",
        name : "SG8.1 Recruit Questions",
        path : "DownloadableForms/SG8.1 Recruit Questions.docx"
    },
    {
        type : "SG82RecruitmentChecklist",
        name : "SG8.2 Recruitment Checklist",
        path : "DownloadableForms/SG8.2 Recruitment Checklist.docx"
    },
];

export default downloadableFormsMap ;
